import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    LFP_BUSCAR_ABONO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.buscar.abono'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_ABONO_SOLICITAR_ENVIO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.abono.solicitar.envio'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_ABONO_CAMBIO_PIN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.abono.cambio.pin'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_ABONO_LIBERAR_PARTIDOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.abono.liberar.partidos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_ABONO_ASIENTO_LIBERAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.abono.asiento.liberar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_ABONO_ASIENTO_RECUPERAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.abono.asiento.recuperar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_PARTIDOS_SESION_ABONADOS_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.partidos.sesion.abonados.precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    LFP_PARTIDOS_SESION_RESERVAR_ASIENTO_SOCIO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('lfp.partidos.sesion.reservar.asiento.socio'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

}

export default {
    actions
};